module.exports = "<!doctype html>\n<html>\n  <head>\n    <meta charset=\"utf-8\">\n  </head>\n\n  <body>\n    <!-- Will be replaced by React -->\n    <div id=\"root\"></div>\n\n    <!-- Load React -->\n    <script src=\"./react.min.js\"></script>\n    <script src=\"./react-dom.min.js\"></script> \n    \n    <!-- Render element -->\n    <script>\n      ReactDOM.render(\n        React.createElement(\n          'h1', null, 'Hello, world!'\n        ),\n        document.getElementById('root')\n      )\n    </script>\n\n  </body>\n\n</html>\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/04_hello_world/hello.example
// module id = 1478
// module chunks = 0